var map = {
	"./App Notion.png": 543,
	"./HOUSE-usecase.png": 9778,
	"./ecommerce-usecase.png": 2401,
	"./finance-usecase.png": 8931,
	"./heart-usecase.png": 3052,
	"./travel-usecase.png": 893,
	"./usecase-care.png": 7867
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 689;